/* eslint-disable react/prop-types */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {get, isEmpty} from 'lodash';
import cx from 'classnames';

import {viewOrderArr} from '../viewOrderArr';
import Logo from '../../../common/svgs/Logo';

const logoStyle = {backgroundColor: '#fafafa'};
@connect(store => ({
  labels: get(store.labels, 'Common', {}),
  account: get(store.staticData, 'account', {}),
  impersonatedUser: get(store.user, 'impersonateUser', {})
}))
export default class NavColumn extends Component {

  static propTypes = {
    navStateChange    : PropTypes.func,
    logoutFunc        : PropTypes.func,
    activeColumnNav   : PropTypes.string,
    navViewState      : PropTypes.object,
    assessment        : PropTypes.bool,
    canShowAssessment : PropTypes.bool,
    submitted         : PropTypes.bool,
    isQualified       : PropTypes.bool,
    hasInterviewed    : PropTypes.bool,
    showInstructions  : PropTypes.bool,
    labels            : PropTypes.object.isRequired,
    account           : PropTypes.object.isRequired,
    impersonatedUser  : PropTypes.object.isRequired,
    isInactivePipeline: PropTypes.object.isRequired
  }

  // Should section be displayed?
  includeSection(heading) {
    if (heading.key === 'Instructions') {
       // show instructions if requested
       return this.props.showInstructions;
    }
    else if (isEmpty(this.props.impersonatedUser)) {
      // Applicant View
      if (this.props.isInactivePipeline) {
        // Applicant in Inactive Pipeline
        return heading.showInactivePipeline;

        // eslint-disable-next-line no-else-return
      } else {
        return (this.props.hasInterviewed || heading.showUnqualified) && (!this.props.submitted || !heading.hideSubmitted);
      }
    }

    // eslint-disable-next-line no-else-return
    else {
      // QS View
      return (this.props.hasInterviewed || heading.showUnqualified) && (!this.props.submitted || !heading.hideSubmitted);
    }
  }

  render() {
  return (
      <div className='applicant-profile-nav'>
        <a className='reset-href' href={this.props.labels.website}>
          <Logo className='logo' style={logoStyle} account={this.props.account}/>
        </a>
        <ul className='applicant-nav-container noTextSelect'>
          {
            viewOrderArr
              .filter(::this.includeSection)
              .map((heading, index) => {
                  const subNavIndex = (heading.key === 'Skills' && this.props.isQualified && this.props.submitted) ? 1 : 0;
                  return (
                    <div
                      data-id={heading.display}
                      key={index}
                      className={cx('applicant-nav-heading noTextSelect', {active: this.props.activeColumnNav === heading.key}, {checkmark: !this.props.submitted && this.props.navViewState[heading.key]})}
                      onClick={this.props.activeColumnNav !== heading && this.props.navStateChange.bind(this, heading.key, heading.subNav && heading.subNav[subNavIndex].key || null)}
                    >
                      {this.props.submitted ? (heading.displaySubmitted || heading.display) : heading.display}
                    </div>
                  );
              })
          }
          {
              this.props.submitted
              &&
              <div
                data-id={'view resume'}
                className={'applicant-nav-heading noTextSelect'}
              >
                <a target='_blank' className='view-resume-btn' href='/applicant/resume'>
                  resume
                </a>
              </div>
          }
          <div
            className='applicant-nav-heading noTextSelect separator'
            > &nbsp;</div>
          <div
            className={cx('applicant-nav-heading noTextSelect', {active: this.props.assessment}, {checkmark: !this.props.submitted && this.props.navViewState.Assessments})}
            style={{display: this.props.canShowAssessment ? 'inline-block' : 'none'}}
            onClick={this.props.showAssessment}
            data-id='Assessments'
            > Assessments</div>
          <div
            className={cx('applicant-nav-heading noTextSelect', {active: this.props.technologySurvey})}
            style={{display: this.props.canShowTechnologySurvey ? 'inline-block' : 'none'}}
            onClick={this.props.showTechnologySurvey}
            data-id='Technology'
            > Technology</div>
        </ul>
        <div className='terms-section noTextSelect' >
          <span> &copy; Work At Home Vintage Experts LLC.</span>
          <a className='terms-link' href='https://wahve.com/privacy-policy/' target='_blank' title='Privacy Policy opens in a new browser tab'>Terms & Privacy</a>
        </div>
      </div>
    );
    }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_NavColumn/index.js